var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4SmokingArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v8H14v-8h55zM20.71 32A6.7 6.7 0 0014 38.71V43h4v-4.29A2.71 2.71 0 0120.71 36H31a11.132 11.132 0 003.73-.66 10.32 10.32 0 006.1-5.73c.555-1.3.84-2.697.84-4.11V25h-4v.5a6.36 6.36 0 01-1.54 4.2A6.751 6.751 0 0131 32H20.71zm1.62-3A10.47 10.47 0 0033 18.5V16h-4v2.5a6.51 6.51 0 01-6.67 6.5h-2.87a12.77 12.77 0 00-8.91 4A13.5 13.5 0 007 38.31V43h4v-4.69c0-5.39 3.79-9.31 9-9.31h2.33zM7 54h4v-8H7v8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Smoking_area.83b54dd2.svg";
export { SvgE4SmokingArea as ReactComponent };